// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","container":"container-2hSE2","icon":"icon-1Ck2m","success":"success-2kBTs"};